export const watchguard_vpn_info = 'WatchGuard Mobile VPN allows you to access company resources from almost anywhere—provided you have an internet connection.'

export const watchguard_vpn_md = `
# WatchGuard Mobile VPN with SSL Client

*Last updated: July 14, 2025*

## Overview

The WatchGuard Mobile VPN with SSL client enables secure remote access to internal network resources using SSL encryption. It is ideal for remote work because it provides a secure and reliable connection to our organization's resources. If you are working remotely, you will need to use the VPN in order to use services like the network drives, TCM, Dash, SOLIDWORKS, and more.

Note: please do not use the VPN while connected to the internet at Bock or TTI. It will not work properly and you may need to restart your device.

## Benefits

- **Remote Access**: Allows you to access company resources from almost anywhere with internet.
- **User-Friendly Interface**: Easy-to-install client software with a simple user interface.
- **Integrated Authentication**: Works with your existing account and Duo.
- **Secure Access**: Uses SSL encryption to protect data sent between your computer and our network.

## Requirements

- Internet access
- A user account with VPN access permissions
- An up to date version of Windows
- Enrollment in Duo MFA

## Getting Started

1. **Install WatchGuard Mobile**:
   - Please contact IT so we can install the VPN for you and give your account permission to use it.

2. **Connect yourself to the internet**:
   - In order to use the VPN you will need to have an internet connection
   - Please connected yourself via WiFi or Ethernet. A mobile hot spot will also work.

3. **Search for and run Mobile VPN with SSL Client**:
   - Search 'Mobile VPN with SSL Client' in the Windows search bar
   - A program with that title and with a magnifying glass with a W icon should show up
   - Launch this program

4. **Connect to the VPN**:
   - Please contact IT if you need the server address.
   - Enter your credentials and connect.
   - You will need to approve a Duo push notification in order to connect.
   - Once connected, you can securely access internal resources.

## Support
- Contact our IT Help Desk

`